import BlocksSubHeader from "../../../components/Blocks/BlocksSubHeader";
import Header from "../../../components/Header/Header";
import ImageBlockList from "../../../components/Image/ImageBlockList";
import SideNavbar from "../../../components/Navbar/SideNavbar";

const Images = () => {
    return (
        <>
            <div className="flex mainWrapper w-full">
                <div className="sidenav-wrapper">
                    <SideNavbar />
                </div>
                <div className="right-container">
                    <div className="header-container">
                        <Header />
                    </div>
                    <div className="body-container">
                        <BlocksSubHeader />
                        <ImageBlockList />
                    </div>
                </div>
            </div>
        </>
    )
}
export default Images;